
document.addEventListener('DOMContentLoaded', () => {
  const explorers = document.querySelectorAll('.gh-chess-explorer');

  explorers.forEach((explorer) => {

    function initBoardCarousel(zoneSelector, namesAttribute) {
      const zone = explorer.querySelector(zoneSelector);
      if (!zone) return;

      const stage = zone.querySelector('.gh-board-stage');
      if (!stage) return;

      const cards = Array.from(
        stage.querySelectorAll('.gh-board-card')
      );

      const modelLabel = zone.querySelector(
        '.gh-board-stage__model'
      );

      if (cards.length < 2) return;

      let modelNames = [];

      try {
        modelNames = JSON.parse(
          explorer.getAttribute(namesAttribute) || '[]'
        );
      } catch (error) {
        modelNames = [];
      }

      let activeIndex = 1;
      let isAnimating = false;

      function render() {
        const total = cards.length;
        const prevIndex = (activeIndex - 1 + total) % total;
        const nextIndex = (activeIndex + 1) % total;

        cards.forEach((card, index) => {
          card.classList.remove(
            'gh-board-card--prev',
            'gh-board-card--active',
            'gh-board-card--next'
          );

          if (index === activeIndex) {
            card.classList.add('gh-board-card--active');
          } else if (index === prevIndex) {
            card.classList.add('gh-board-card--prev');
          } else if (index === nextIndex) {
            card.classList.add('gh-board-card--next');
          }
        });

        if (modelLabel) {
          const name =
            modelNames[activeIndex] ||
            `BOARD ${activeIndex + 1}`;

          modelLabel.textContent = '';

          modelLabel.appendChild(
            document.createTextNode(name + ' ')
          );

          const counter = document.createElement('span');

          counter.textContent =
            `· ${String(activeIndex + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;

          modelLabel.appendChild(counter);
        }
      }

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          const link = card.dataset.boardLink;
          if (!link) return;

          window.location.href = link;
        });
      });

      function moveBoard(direction) {
        if (isAnimating) return;
        activeIndex = (activeIndex + direction + cards.length) % cards.length;
        isAnimating = true;
        render();
        window.setTimeout(() => { isAnimating = false; }, 720);
      }

      const actions = zone.querySelector('.gh-board-stage__actions');
      if (actions && !actions.querySelector('.gh-board-nav')) {
        const isTurkish = document.documentElement.lang.startsWith('tr');
        const controls = document.createElement('div');
        controls.className = 'gh-board-nav';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', isTurkish ? 'Tahta modeli seçimi' : 'Board model navigation');

        [-1, 1].forEach((direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gh-board-nav__button';
          button.textContent = direction < 0 ? '\u2190' : '\u2192';
          button.setAttribute('aria-label', direction < 0
            ? (isTurkish ? 'Önceki tahta modeli' : 'Previous board model')
            : (isTurkish ? 'Sonraki tahta modeli' : 'Next board model'));
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            moveBoard(direction);
          });
          controls.appendChild(button);
        });

        actions.prepend(controls);
        if (modelLabel) {
          modelLabel.setAttribute('aria-live', 'polite');
          modelLabel.setAttribute('aria-atomic', 'true');
        }
      }

      zone.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (isAnimating) return;
          if (Math.abs(event.deltaY) < 8) return;

          const direction = event.deltaY > 0 ? 1 : -1;

          moveBoard(direction);
        },
        { passive: false }
      );

      render();
    }

    initBoardCarousel(
      '.gh-chess-explorer__choice--solid',
      'data-solid-board-names'
    );

        initBoardCarousel(
      '.gh-chess-explorer__choice--mdf',
      'data-mdf-board-names'
    );
        // SHOP BY BOARD / SHOP BY THEME TAB SWITCHING

    const tabs = explorer.querySelectorAll(
      '[data-gh-explorer-tab]'
    );

    const panels = explorer.querySelectorAll(
      '[data-gh-explorer-panel]'
    );

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const selectedTab = tab.dataset.ghExplorerTab;

        tabs.forEach((item) => {
          const isActive =
            item.dataset.ghExplorerTab === selectedTab;

          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          const isActive =
            panel.dataset.ghExplorerPanel === selectedTab;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
    
    // SHOP BY THEME — GALLERY NAVIGATION

    const themeGallery = explorer.querySelector('.gh-theme-gallery');

    if (themeGallery) {
      const track = themeGallery.querySelector('.gh-theme-gallery__track');
      const cards = Array.from(
        themeGallery.querySelectorAll('.gh-theme-gallery__card')
      );
      const prevButton = themeGallery.querySelector(
        'button[aria-label="Previous theme"]'
      );
      const nextButton = themeGallery.querySelector(
        'button[aria-label="Next theme"]'
      );
      const counter = themeGallery.querySelector(
        '.gh-theme-gallery__counter'
      );

      let currentIndex = 0;

      function updateThemeGallery() {
        if (!track || !cards.length) return;

        track.scrollTo({
          left: cards[currentIndex].offsetLeft - cards[0].offsetLeft,
          behavior: 'smooth'
        });

        if (counter) {
          const visibleCount = Math.min(3, cards.length);
          const start = currentIndex + 1;
          const end = Math.min(currentIndex + visibleCount, cards.length);

          counter.textContent =
            `${String(start).padStart(2, '0')} — ${String(end).padStart(2, '0')} / 09`;
        }
      }
      
      // SHOP BY THEME — MOUSE WHEEL SCROLL

      if (track && cards.length > 3) {
        let wheelLocked = false;

        track.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaY) < 8) return;

          event.preventDefault();

          if (wheelLocked) return;

          const maxIndex = Math.max(0, cards.length - 3);
          const direction = event.deltaY > 0 ? 1 : -1;

          currentIndex = Math.max(
            0,
            Math.min(currentIndex + direction, maxIndex)
          );

          updateThemeGallery();

          wheelLocked = true;

          window.setTimeout(() => {
            wheelLocked = false;
          }, 550);
        }, { passive: false });
      }


      if (prevButton && nextButton && cards.length) {
        nextButton.addEventListener('click', () => {
          currentIndex = Math.min(currentIndex + 1, Math.max(0, cards.length - 3));
          updateThemeGallery();
        });

        prevButton.addEventListener('click', () => {
          currentIndex = Math.max(currentIndex - 1, 0);
          updateThemeGallery();
        });
      }
    }


    // Close CHESS mega menu when mouse leaves the menu area
    const megaMenuContent = explorer.closest('.mega-menu__content');
    const megaMenuDetails = explorer.closest('details.mega-menu');

    if (megaMenuContent && megaMenuDetails) {
      megaMenuContent.addEventListener('mouseleave', (event) => {
        // Do not close when moving to another element inside the menu
        if (
          event.relatedTarget &&
          megaMenuContent.contains(event.relatedTarget)
        ) {
          return;
        }

        megaMenuDetails.removeAttribute('open');
      });
    }

  });
});
